import { DateFormats } from '@strata/helper-functions';
import { StatusIndicator } from '@strata/react-status-indicators';
import dayjs from 'dayjs';

export const PLATFORM_ELIGIBILITY_PENDING = 'PENDING';

export interface EligibilityDisplay {
    label: string;
    status: (typeof StatusIndicator.Status)[keyof typeof StatusIndicator.Status];
    tooltipText?: string;
}

export const computeWillBeUnmanagedOnDate = (
    pendingAtIso?: string | null,
    delayedUnmanagementDays?: number | null,
) => {
    if (pendingAtIso == null || delayedUnmanagementDays == null || delayedUnmanagementDays <= 0) {
        return null;
    }

    return dayjs(pendingAtIso).add(delayedUnmanagementDays, 'day').format(DateFormats.HYPHEN_DATE);
};

const ELIGIBILITY_MAP: Record<string, EligibilityDisplay> = {
    ACTIVE: {
        label: 'ACTIVE',
        status: StatusIndicator.Status.SUCCESS,
        tooltipText: 'Patient enrollment is active.',
    },
    PENDING: {
        label: 'MONITORING',
        status: StatusIndicator.Status.WARNING,
        tooltipText:
            'Monitoring enrollment. Coverage terms if active enrollment is not received before the grace period ends.',
    },
    INACTIVE: {
        label: 'TERMED',
        status: StatusIndicator.Status.CAUTION,
        tooltipText: 'Patient enrollment is termed.',
    },
};

export const getMemberEligibilityStatusDisplay = (
    enrollmentStatus?: string | null,
): EligibilityDisplay | null => {
    if (enrollmentStatus == null) {
        return null;
    }

    return (
        ELIGIBILITY_MAP[enrollmentStatus] ?? {
            label: enrollmentStatus,
            status: StatusIndicator.Status.DEFAULT,
        }
    );
};
